const sizesSettings = {
  //breakpoints: ["40em", "64em"],
  sizes: {
    //header: ['4.5rem', '6rem', '6rem'],
    //content: '52.5rem',
    //sidebar: '29.25rem',
  },
}

export default sizesSettings
